<template>
  <div class="quote-page">
    <el-card>
      <div slot="header" class="clearfix">
        <span>智能查价 · 快捷下单</span>
      </div>
      <el-form :inline="true" size="small">
        <el-form-item label="对外渠道">
          <el-select v-model="query.publicChannelId" placeholder="选择渠道" filterable clearable style="width:220px">
            <el-option v-for="c in channels" :key="c.id" :label="c.name" :value="c.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="FBA代码">
          <el-select
            v-model="query.fbacode"
            filterable
            clearable
            placeholder="从系统选择"
            style="width:200px"
            @change="onQueryFbaChange"
          >
            <el-option
              v-for="item in fbaOptions"
              :key="'qry-fba-' + item.code"
              :label="item.label"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="邮编">
          <el-input v-model="query.zip" placeholder="选填" style="width:130px" />
        </el-form-item>
        <el-form-item label="重量kg">
          <el-input-number v-model="query.kg" :min="0" style="width:140px" />
        </el-form-item>
        <el-form-item label="体积cbm">
          <el-input-number v-model="query.cbm" :min="0" :precision="2" style="width:140px" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" @click="doQuote">查 价</el-button>
        </el-form-item>
      </el-form>

      <el-alert
        v-if="message"
        :title="message"
        type="warning"
        :closable="false"
        show-icon
        style="margin-bottom:10px"
      />

      <el-table :data="options" v-loading="loading" border stripe size="mini" style="width:100%" class="quote-result-table">
        <el-table-column label="渠道" prop="label" min-width="100" show-overflow-tooltip />
        <el-table-column label="单价" prop="unitPrice" width="72" />
        <el-table-column label="计费重" prop="billingNum" width="72" />
        <el-table-column label="总价" prop="saleTotal" width="88" />
        <el-table-column label="币种" prop="currency" width="56" />
        <el-table-column label="时效" prop="transitDays" width="80" show-overflow-tooltip />
        <el-table-column label="配送" prop="deliverywayTxt" width="88" show-overflow-tooltip />
        <el-table-column label="税" prop="dutyTypeTxt" width="56" />
        <el-table-column label="备注" prop="quoteNote" min-width="100" show-overflow-tooltip />
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="primary" size="mini" @click="openOrder(row)">快捷下单</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 快捷下单弹窗 -->
    <el-dialog title="快捷下单" :visible.sync="orderDialog" width="720px" :close-on-click-modal="false">
      <el-form ref="orderForm" :model="orderForm" label-width="100px" size="small">
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="渠道">
              <el-input :value="selectedOption && selectedOption.label" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="查价总价">
              <el-input :value="selectedOption ? (selectedOption.currency || 'RMB') + ' ' + selectedOption.saleTotal : ''" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="运单号">
              <el-input v-model="orderForm.clientNo" placeholder="选填" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申报类型">
              <el-select v-model="orderForm.declareType" placeholder="请选择" style="width:100%">
                <el-option label="买单" value="0" />
                <el-option label="0110退税" value="1" />
                <el-option label="自拖自报" value="3" />
                <el-option label="合并报关" value="4" />
                <el-option-group label="特殊监管方式">
                  <el-option label="9610报关" value="8" />
                  <el-option label="9710报关" value="9" />
                  <el-option label="9810报关" value="10" />
                  <el-option label="1039市场采购" value="11" />
                </el-option-group>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="配送类型">
              <el-select v-model="orderForm.shipmentType" placeholder="请选择" style="width:100%">
                <el-option label="FBA地址" value="0" />
                <el-option label="私人地址" value="1" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="FBA代码">
              <el-select
                v-model="orderForm.shipmentCode"
                filterable
                clearable
                placeholder="从系统选择"
                style="width:100%"
                :disabled="orderForm.shipmentType === '1'"
                @change="onOrderFbaChange"
              >
                <el-option
                  v-for="item in fbaOptions"
                  :key="'ord-fba-' + item.code"
                  :label="item.label"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12" v-if="orderForm.shipmentType === '1'">
          <el-col :span="12">
            <el-form-item label="收件人">
              <el-input v-model="orderForm.shipmentContact" placeholder="收件人姓名" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电话">
              <el-input v-model="orderForm.shipmentTel" placeholder="联系电话" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮编">
              <el-input v-model="orderForm.shipmentZip" placeholder="邮编" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="国家">
              <el-input v-model="orderForm.shipmentCountry" placeholder="如 US" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="地址">
              <el-input v-model="orderForm.shipmentAddress" placeholder="详细地址" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="12">
          <el-col :span="8">
            <el-form-item label="送货地" required>
              <el-select v-model="orderForm.cenPlace" placeholder="必选" filterable clearable style="width:100%" @change="onPlaceChange">
                <el-option-group v-for="group in placeData" :key="group.label" :label="group.label">
                  <el-option v-for="item in group.options" :key="item.id" :label="item.cname" :value="item.cname" />
                </el-option-group>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="业务类型">
              <el-cascader
                v-model="orderForm.topOcean"
                :options="oceanData"
                :props="{ value: 'name', label: 'name' }"
                placeholder="选择业务类型"
                clearable
                style="width:100%"
                @change="onOceanChange"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="送货时间" required>
              <el-date-picker
                v-model="orderForm.dispatchTime"
                type="datetime"
                placeholder="必选"
                value-format="timestamp"
                style="width:100%"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 货物信息:快捷下单只填汇总,不填产品明细(与管理端一致) -->
        <el-row :gutter="12">
          <el-col :span="8">
            <el-form-item label="件数">
              <el-input-number v-model="orderForm.ctn" :min="1" :precision="0" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="总重量kg">
              <el-input-number v-model="orderForm.totalKg" :min="0" :precision="2" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="总体积cbm">
              <el-input-number v-model="orderForm.totalCbm" :min="0" :precision="3" style="width:100%" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="备注">
          <el-input v-model="orderForm.remark" type="textarea" :rows="2" placeholder="选填" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="orderDialog = false">取 消</el-button>
        <el-button type="primary" size="small" :loading="submitting" @click="submitOrder">提交下单</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import httpApi from "@/http/api";

export default {
  name: "Quote",
  data() {
    return {
      channels: [],
      fbaOptions: [],
      loading: false,
      message: "",
      options: [],
      query: {
        publicChannelId: null,
        fbacode: "",
        zip: "",
        kg: null,
        cbm: null,
        limit: 5
      },
      // 快捷下单
      orderDialog: false,
      submitting: false,
      selectedOption: null,
      orderForm: {
        clientNo: "",
        declareType: "0",
        shipmentType: "0",
        shipmentCode: "",
        shipmentZip: "",
        shipmentCountry: "",
        shipmentContact: "",
        shipmentTel: "",
        shipmentAddress: "",
        ctn: 1,
        totalKg: 0,
        totalCbm: 0,
        remark: "",
        cenPlace: "",
        cenId: "",
        topOcean: ["拼柜"],
        freightMethod: "0",
        containerType: "",
        dispatchTime: null
      },
      placeData: [],
      oceanData: [
        { id: "0", name: "拼柜" },
        { id: "1", name: "整柜", children: [] }
      ]
    };
  },
  created() {
    this.loadChannels();
    this.loadFbaOptions();
    this.loadPlaceOder();
    this.loadContainer();
  },
  methods: {
    // FBA仓：与正式下单一致，从后台参数拉取（优先按客户服务市场过滤）；按 code 去重
    loadFbaOptions() {
      const apply = list => {
        const map = new Map();
        (list || []).forEach(item => {
          if (!item || !item.code || map.has(item.code)) return;
          map.set(item.code, {
            ...item,
            label: (item.code || "") + " " + (item.zip || "")
          });
        });
        this.fbaOptions = Array.from(map.values());
      };
      httpApi
        .listUserParams({ params: { type: "sys_fbacode", enable: "1" } })
        .then(res => {
          if (res.data.code === "ok" && (res.data.data || []).length) {
            apply(res.data.data);
          } else {
            return httpApi.listParams({ params: { type: "sys_fbacode", enable: "1" } }).then(r2 => {
              if (r2.data.code === "ok") apply(r2.data.data);
            });
          }
        })
        .catch(() => {
          httpApi.listParams({ params: { type: "sys_fbacode", enable: "1" } }).then(res => {
            if (res.data.code === "ok") apply(res.data.data);
          });
        });
    },
    onQueryFbaChange(code) {
      const hit = this.fbaOptions.find(i => i.code === code);
      if (hit && hit.zip) {
        this.query.zip = hit.zip;
      }
    },
    onOrderFbaChange(code) {
      const hit = this.fbaOptions.find(i => i.code === code);
      if (hit && hit.zip) {
        this.orderForm.shipmentZip = hit.zip;
      }
    },
    // 送货地列表
    loadPlaceOder() {
      httpApi.getPort({ params: { type: "sys_dispatch_place" } }).then(res => {
        if (res.data.code === "ok") {
          this.placeData = (res.data.data || []).map(g => ({ label: g.label, options: g.list || [] }));
        }
      });
    },
    // 柜型列表(整柜 children)
    loadContainer() {
      httpApi.listParams({ params: { type: "sys_container_type", enable: "1" } }).then(res => {
        if (res.data.code === "ok") {
          this.oceanData[1].children = res.data.data || [];
        }
      });
    },
    onPlaceChange(name) {
      const found = this.placeData.flatMap(g => g.options || []).find(o => o.cname === name);
      this.orderForm.cenId = found ? found.id : "";
    },
    onOceanChange(val) {
      this.orderForm.freightMethod = val && val[0] === "整柜" ? "1" : "0";
      this.orderForm.containerType = val && val[1] ? val[1] : "";
    },
    loadChannels() {
      httpApi.listPublicChannelForCustomer({}).then(res => {
        if (res.data.code === "ok") {
          this.channels = res.data.data || [];
        }
      });
    },
    doQuote() {
      if (!this.query.publicChannelId) {
        this.$message.warning("请选择对外渠道");
        return;
      }
      if (!this.query.fbacode && !this.query.zip) {
        this.$message.warning("请选择 FBA 代码或填写邮编");
        return;
      }
      if ((!this.query.kg || this.query.kg <= 0) && (!this.query.cbm || this.query.cbm <= 0)) {
        this.$message.warning("请填写重量或体积");
        return;
      }
      this.loading = true;
      this.message = "";
      httpApi.smartQuote({ params: this.query }).then(res => {
        this.loading = false;
        if (res.data.code === "ok") {
          this.options = res.data.data.options || [];
          if (!this.options.length) {
            this.message = "当前渠道暂无可用方案，请调整重量/体积或换渠道";
          }
        } else {
          this.message = res.data.message || "查价失败";
        }
      }).catch(() => {
        this.loading = false;
        this.message = "查价失败，请稍后重试";
      });
    },
    // 打开快捷下单弹窗,带入查价参数
    openOrder(row) {
      this.selectedOption = row;
      this.orderDialog = true;
      this.orderForm.clientNo = "";
      this.orderForm.shipmentCode = this.query.fbacode || "";
      const fba = this.fbaOptions.find(i => i.code === this.orderForm.shipmentCode);
      this.orderForm.shipmentZip = (fba && fba.zip) || this.query.zip || "";
      this.orderForm.ctn = 1;
      this.orderForm.totalKg = this.query.kg || 0;
      this.orderForm.totalCbm = this.query.cbm || 0;
      this.orderForm.remark = "";
      this.orderForm.cenPlace = "";
      this.orderForm.cenId = "";
      this.orderForm.topOcean = ["拼柜"];
      this.orderForm.freightMethod = "0";
      this.orderForm.containerType = "";
      this.orderForm.dispatchTime = null;
    },
    // 提交快捷下单(不填产品,先建单,与管理端快捷下单一致)
    submitOrder() {
      if (!this.orderForm.shipmentCode && this.orderForm.shipmentType === "0") {
        this.$message.warning("请选择 FBA 代码");
        return;
      }
      if (!this.orderForm.cenId || !this.orderForm.cenPlace) {
        this.$message.warning("请选择送货地");
        return;
      }
      if (!this.orderForm.dispatchTime) {
        this.$message.warning("请选择送货时间");
        return;
      }
      if (this.orderForm.shipmentType === "1") {
        if (!this.orderForm.shipmentContact || !this.orderForm.shipmentTel || !this.orderForm.shipmentZip) {
          this.$message.warning("请完善收件人信息(姓名/电话/邮编)");
          return;
        }
      }
      // 费用快照:与财务录费用约定对齐(费用名/英文名/RMB)
      const fees = [];
      if (this.selectedOption && this.selectedOption.saleTotal != null) {
        fees.push({
          feeName: "海运费",
          feeNameEn: "OF HYF",
          currency: "RMB",
          price: this.selectedOption.unitPrice,
          num: this.selectedOption.billingNum,
          money: this.selectedOption.saleTotal
        });
      }
      this.submitting = true;
      // 货物信息汇总:件数/总重/总体积组装成 shipmentList 一行(与管理端快捷下单一致,不填产品)
      const shipmentList = [{
        ctn: this.orderForm.ctn || 0,
        kg: this.orderForm.totalKg || 0,
        cbm: this.orderForm.totalCbm || 0
      }];
      httpApi.addQuick({
        channelId: (this.selectedOption && this.selectedOption.supplyChannelId) || this.query.publicChannelId,
        clientNo: this.orderForm.clientNo,
        importerType: "1",
        insurance: "0",
        pickupType: "0",
        declareType: this.orderForm.declareType,
        shipmentType: this.orderForm.shipmentType,
        shipmentCode: this.orderForm.shipmentCode,
        // FBA 地址由后端按仓码回填邮编;私人地址才传前端邮编
        shipmentZip: this.orderForm.shipmentType === "1" ? this.orderForm.shipmentZip : null,
        shipmentCountry: this.orderForm.shipmentCountry || null,
        shipmentContact: this.orderForm.shipmentContact || null,
        shipmentTel: this.orderForm.shipmentTel || null,
        shipmentAddress: this.orderForm.shipmentAddress || null,
        remark: this.orderForm.remark || null,
        dispatchId: this.orderForm.cenId,
        dispatchPlace: this.orderForm.cenPlace,
        freightMethod: this.orderForm.freightMethod,
        containerType: this.orderForm.containerType || null,
        dispatchTime: Math.floor(this.orderForm.dispatchTime / 1000),
        shipmentList: shipmentList,
        quoteFeeList: fees
      }).then(res => {
        this.submitting = false;
        if (res.data.code === "ok") {
          this.$message.success("下单成功：" + res.data.data);
          this.orderDialog = false;
          this.$router.push({ path: "/myorder" });
        } else {
          this.$message.error(res.data.message || "下单失败");
        }
      }).catch(err => {
        this.submitting = false;
        const msg =
          (err && err.response && err.response.data && err.response.data.message) ||
          "下单失败，请稍后重试";
        this.$message.error(msg);
      });
    }
  }
};
</script>

<style scoped>
.quote-page .quote-result-table {
  max-width: 960px;
}
</style>
